<template>
  <div class="view-connections-modal">
    <div class="connection-list-wrapper">
      <a
        data-w-id="150735b1-3e6f-fc67-a109-a12e2e2f0ba7"
        href="#"
        class="link-block-5 w-inline-block"
        @click="cancel"
        ><img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt=""
      /></a>
      <div class="div-block-52 connection">
        <h1 class="modal-heading connection">My connections</h1>
      </div>
      <div class="connections">
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
        <a href="#" class="div-block-47 w-inline-block">
          <div class="div-block-48">
            <img
              src="@/assets/timeslot-images/user.png"
              loading="lazy"
              width="50"
              alt=""
            />
          </div>
          <div>
            <div class="text-block-34">Idris Yusuf</div>
            <div class="text-block-35">Product Designer</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewConnectionsModal",
  props: {
    cancel: Function
  }
};
</script>

<style scoped></style>
